import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type ControlMinuteState = {
  stateControlMinute: boolean;
  setStateControlMinute: (type: boolean) => void;
};

const useControlMinuteState = create(
  persist<ControlMinuteState>(
    set =>
      ({
        stateControlMinute: false,
        setStateControlMinute: (type: boolean) =>
          set({ stateControlMinute: type }),
      } as ControlMinuteState),
    {
      name: '@tenGovUseControlMinuteStateStore',
    },
  ),
);

export default useControlMinuteState;
